export default __webpack_public_path__ + "static/media/W-1440-D.a928ea9b.png";